/*
    Popup Class
    Version:
    ---
    Frondevo corp.
    http://frondevo.com
    Author: Andrew "Bikkuri" Kosyack
*/
function Popup(params) {
    'use strict';
    var self = this;

    self.isMobDevice = self.isMobDevice = FRONDEVO ? FRONDEVO.controls.isMobDevice : false;
    self.elems = {
        $menu: $('.header-menu').eq(0),
        $menuItems: $('.header-menu .m-item'),
        $popup: $('.fd__popup'),
        $popupHtml: $('.pop-content').html().replace(/style=\"display: none;\"/g, ''),
        $hbMenu: $('.fd__hb-menu')
    };

    self.elems.$popup.remove();

    self.settings = {
    };

    $.extend(self.settings, params);

    self.popupCode = function (title, content, close){
        title = title ? title : '';
        content = content ? content : '';
        close = close ? close : '';
        return '<div class="fd__popup tEndElement">' +
            '    <div class="pop-wrap">' +
            '        <div class="queue-wrap queueFromTop">' +
            '            <h2 class="pop-title tEndElement queue queue1">' + title + '</h2>' +
            '        </div>' +
            '        <div class="pop-content queue-wrap queueFromBottom">' + content + '</div>' +
            '        <div title="' + close + '" class="pop-btn-close"></div>' +
            '    </div>' +
            '</div>';
    };
    self.popupMenuCode = function (content, close){
        content = content ? content : '';
        close = close ? close : '';

        return '<div class="fd__popup fd__popup_v2 tEndElement">' +
            '    <div class="pop-wrap">' + self.elems.$popupHtml + '</div>' +
            '    <div title="' + close + '" class="pop-btn-close">' +
            '    <span></span>' +
            '    </div>' +
            '</div>';
    };
    self.popups = {
    };


    self.init(params);

    return this;
}

Popup.prototype = {
    init: function () {
        'use strict';
        var self = this;

        self.controls();

        return this;
    },

    getMenuPopup: function (callback) {
        'use strict';
        var self = this,
            elems = self.elems,
            code = '<ul class="popup-menu">',
            dataCode = '';

        elems.$menuItems.each(function (key, value) {
            var obj = {
                popup: $(value).find('a, span').attr('data-popup'),
                popupTitle: $(value).find('a, span').attr('data-popup-title'),
                popupClose: $(value).find('a, span').attr('data-popup-close')
            };

            if (obj.popup) {
                dataCode = ' data-popup="' + obj.popup + '" data-popup-title="' + obj.popupTitle + '" data-popup-close="' + obj.popupClose + '"';
            }

            if ($(value).hasClass('active')) {
                code += '<li class="pm-item active queue queue' + (key + 1) + '"' + dataCode + '><span>' + $(value).text() + '</span></li>';
            } else {
                var $lnk = $(value).find('a').eq(0);
                code += '<li class="pm-item queue queue' + (key + 1) + '"' + dataCode + '><a href="' + $lnk.attr('href') + '">' + $lnk.text() + '</a></li>';
            }
        });
        code += '</ul>';
        self.popups.menu.code = code;

        if (typeof callback === 'function') {
            callback();
        }

        return this;
    },

    getPopupContent: function (obj, callback) {
        'use strict';
        var self = this;

        if (obj.popup === 'menu') {
            self.popups[obj.popup] = {
                title: obj.title,
                close: obj.close,
                popup: obj.popup
            };
            self.getMenuPopup(function () {
                if (typeof callback === 'function') {
                    callback(obj.popup);
                }
            });
        } else {
            var url = obj.url ? obj.url : 'popup/';

            /*$.ajax({
                url: url + obj.popup + '.html',
                dataType : 'html',
                complete: function (xhr, response) {
                    console.log(xhr, response);
                    self.popups[obj.popup] = {
                        title: obj.title,
                        close: obj.close,
                        popup: obj.popup,
                        code: xhr.responseText
                    };

                    if (typeof callback === 'function') {
                        callback(obj.popup);
                    }
                },
                error: function () {
                    alert('error!');
                }
            });*/
            self.popups[obj.popup] = {
                title: obj.title,
                close: obj.close,
                popup: obj.popup,
                code: self.elems.$popupHtml
            };

            if (typeof callback === 'function') {
                callback(obj.popup);
            }
        }

        return this;
    },

    openPopup: function (contentId) {
        'use strict';

        var self = this,
            $popup = {};

        switch (contentId) {
            case 'gmenu':
                $popup = $(self.popupMenuCode(self.popups[contentId].code, self.popups[contentId].close))
                break;
            default:
                $popup = $(self.popupCode(self.popups[contentId].title, self.popups[contentId].code, self.popups[contentId].close))
        }

        self.elems.$popup = $popup;
        self.elems.$popupTitleWrap = $popup.find('.pop-title').eq(0).parent();
        self.elems.$popupContent = $popup.find('.pop-wrap').eq(0);

        self.elems.$popupContent.removeClass('animate in');
        self.elems.$popupTitleWrap.removeClass('animate in');


        $('html').addClass('no-scroll');
        //$('.main-wrap').append($popup);
        $('body').append($popup);

        setTimeout(function () {
            $popup.addClass('visible');
            self.elems.$hbMenu.addClass('hidden');
            setTimeout(function () {
                /*self.elems.$popupContent.addClass('animate in');
                self.elems.$popupTitleWrap.addClass('animate in');*/
                self.elems.$popup.find('.queue-wrap').addClass('animate in');
                //self.elems.$popupTitleWrap.addClass('animate in');
            });
        }, 100);

        return this;
    },

    closePopup: function () {
        'use strict';

        var self = this,
            $title = self.elems.$popup.find('.pop-title').length ? self.elems.$popup.find('.pop-title') : self.elems.$popupContent.find('.fd__stripe').eq(0);

        self.elems.$popup.find('.queue-wrap').removeClass('in');
        /*self.elems.$popupContent.removeClass('in');
        self.elems.$popupTitleWrap.removeClass('in');*/

        $title.data('tcallback', {
            prop: 'opacity',
            callback: function () {
                self.elems.$popup.removeClass('visible');
                self.elems.$hbMenu.removeClass('hidden');
                $('html').removeClass('no-scroll');

                /*self.elems.$popupContent.removeClass('in');
                 self.elems.$popupTitleWrap.removeClass('in');*/

                // set callback after popup animation
                self.elems.$popup.data('tcallback', {
                    prop: 'opacity',
                    callback: function () {
                        self.elems.$popup.remove();
                        self.elems.$popup = null;
                    }
                });
                $title.data('tcallback', null);
            }
        });




        return this;
    },

    updateContent: function (obj) {
        'use strict';
        var self = this,
            $title = self.elems.$popup.find('.pop-title'),
            $qWrap = self.elems.$popup.find('.queue-wrap');

        $qWrap.eq(0).removeClass('in');
        $qWrap.eq(1).removeClass('in');

        // set callback after popup animation
        $title.data('tcallback', {
            prop: 'opacity',
            callback: function () {
                self.getPopupContent(obj, function () {
                    self.elems.$popupContent
                        .empty()
                        .append(self.popups[obj.popup].code);
                    $title.html(obj.title);
                    $qWrap = self.elems.$popup.find('.queue-wrap');

                    self.elems.$popupTitleWrap = self.elems.$popup.find('.pop-title').eq(0).parent();
                    self.elems.$popupContent = self.elems.$popup.find('.pop-content').eq(0);

                    $qWrap.eq(0).addClass('queueFromTop');
                    $qWrap.eq(1).addClass('queueFromBottom');

                    setTimeout(function () {
                        $qWrap.eq(0).addClass('in');
                        $qWrap.eq(1).addClass('in');
                        self.elems.$popup.find('.pop-title').data('tcallback', null);
                    }, 100);
                });
            }
        });

        return false;
    },

    createPopupObject: function (obj) {
        'use strict';
        var self = this;

        // если попап открыт
        if (!!self.elems.$popup) {
            obj.title = $obj.attr('data-popup-title');
            self.updateContent(obj);
            // если попап закрыт
        } else {
            if (self.popups[obj.popup]) {
                self.openPopup(obj.popup);
            } else {
                self.getPopupContent(obj, function (popup) {
                    self.openPopup(popup);
                });
            }
        }

        return this;
    },

    controls: function () {
        'use strict';
        var self = this,
            clickEvent = self.isMobDevice ? 'touchend MSPointerDown click' : 'click';

        $(document).on(clickEvent, '[data-popup]', function (event) {
            if (self.elems.$popup) {
                self.elems.$popup.remove();
                self.elems.$popup = null;
            }
            var $obj = $(this),
                obj = {
                    popup: $obj.attr('data-popup'),
                    title: $obj.attr('data-popup-title'),
                    close: $obj.attr('data-popup-close'),
                    url: $obj.attr('data-popup-url')
                };

            self.createPopupObject(obj);

            event.preventDefault();

        });

        $(document).on(clickEvent, '.pop-btn-close', function (event) {
            self.closePopup();
        });



        // temporary
        /*self.createPopupObject({
            popup: 'menu',
            title: 'Menu',
            close: 'Close',
            url: 'popup/'
        });*/

        return this;
    }
};